/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as r from "react";
import s from "prop-types";
import { classNames as t } from "@progress/kendo-react-common";
const a = (e) => /* @__PURE__ */ r.createElement("div", { style: e.style, className: t("k-card-footer", e.className) }, e.children);
a.propTypes = {
  className: s.string
};
export {
  a as CardFooter
};
